import {
  KeywordGetResDTO,
  KeywordPostReqDTO,
  KeywordPutReqDTO,
  CategoryGetResDTO,
  KeywordsWithCategoryGetResDTO,
} from "../api/keyword-dto.js";

/**
 * Keyword 모델 정의
 * 프론트엔드에서 사용할 Keyword 타입
 */
export interface Keyword {
  id: string;
  nameKo: string;
  nameEn?: string;
  studyLinks: string[];
  descKo: string;
  descEn: string;
  categoryId: string;
  categoryNameKo: string;
  categoryNameEn?: string;
  numOfArticles: number;
  createdAt: string;
  updatedAt: string;
}

export interface Category {
  id: string;
  nameKo: string;
  nameEn?: string;
  numOfArticles: number;
  createdAt: string;
  updatedAt: string;
}

export interface KeywordsWithCategoryData {
  categoryId: string;
  categoryNameKo: string;
  categoryNameEn?: string;
  keywords: Keyword[];
}

/**
 * DTO를 Keyword 모델로 변환하는 함수
 */
export const toKeyword = (dto: KeywordGetResDTO): Keyword => {
  return {
    id: dto.id,
    nameKo: dto.nameKo,
    nameEn: dto.nameEn,
    studyLinks: dto.studyLinks,
    descKo: dto.descKo,
    descEn: dto.descEn,
    categoryId: dto.categoryId,
    categoryNameKo: dto.categoryNameKo,
    categoryNameEn: dto.categoryNameEn,
    numOfArticles: dto.numOfArticles,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};

/**
 * DTO를 Category 모델로 변환하는 함수
 */
export const toCategory = (dto: CategoryGetResDTO): Category => {
  return {
    id: dto.id,
    nameKo: dto.nameKo,
    nameEn: dto.nameEn,
    numOfArticles: dto.numOfArticles,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};

/**
 * DTO를 KeywordsWithCategoryData 모델로 변환하는 함수
 */
export const toKeywordsWithCategoryData = (
  dto: KeywordsWithCategoryGetResDTO,
): KeywordsWithCategoryData => {
  return {
    categoryId: dto.id,
    categoryNameKo: dto.nameKo,
    categoryNameEn: dto.nameEn,
    keywords: dto.keywords.map(toKeyword),
  };
};

/**
 * Keyword 모델을 POST 요청 DTO로 변환하는 함수
 */
export const toKeywordPostReqDTO = (
  keyword: Omit<
    Keyword,
    "id" | "createdAt" | "updatedAt" | "categoryNameKo" | "categoryNameEn"
  >,
): KeywordPostReqDTO => {
  return {
    nameKo: keyword.nameKo,
    nameEn: keyword.nameEn,
    descKo: keyword.descKo,
    descEn: keyword.descEn,
    studyLinks: keyword.studyLinks,
    categoryId: keyword.categoryId,
    numOfArticles: keyword.numOfArticles,
  };
};

/**
 * Keyword 모델을 PUT 요청 DTO로 변환하는 함수
 */
export const toKeywordPutReqDTO = (
  keyword: Partial<Keyword> & { id: string },
): KeywordPutReqDTO => {
  return {
    id: keyword.id,
    nameKo: keyword.nameKo,
    nameEn: keyword.nameEn,
    descKo: keyword.descKo,
    descEn: keyword.descEn,
    studyLinks: keyword.studyLinks,
    categoryId: keyword.categoryId,
    numOfArticles: keyword.numOfArticles,
    updatedAt: keyword.updatedAt || new Date().toISOString(),
  };
};
